/* import __COLOCATED_TEMPLATE__ from './fin-readiness-qa-section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type ContentSuggestionsService from 'embercom/services/content-suggestions-service';
import { use } from 'ember-resources/util/function-resource';
import { AsyncData } from 'embercom/resources/utils/async-data';
import { taskFor } from 'ember-concurrency-ts';

interface Args {}

export default class FinReadinessQaSection extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare store: Store;
  @service declare contentSuggestionsService: ContentSuggestionsService;

  @use questionAnswerPairsLoader = AsyncData<any[]>(async () => {
    let topics = taskFor(
      this.contentSuggestionsService.loadQuestionAnswerPairsForGettingStarted,
    ).perform();
    return topics;
  });

  get questionAnswerPairs() {
    return this.questionAnswerPairsLoader.value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::FinReadinessQaSection': typeof FinReadinessQaSection;
  }
}
